// removed by extract-text-webpack-plugin
module.exports = {"labelError":"formFields_labelError_1mlwy","formInput":"formFields_formInput_3JBjH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/FormFields/formFields.css
// module id = 360
// module chunks = 0